import { createContext } from 'react';
import { RhumbAction, ReporterAction } from './types';
export interface RhumbContextValue {
  id: number;
  dispatch: (action: RhumbAction) => void;
  reportAction: (action: ReporterAction) => void;
  trackVisibility?: boolean;
}

export default createContext<RhumbContextValue>({
  id: 0,
  dispatch: () => {},
  reportAction: () => {},
  trackVisibility: false,
});
